









import { Component, Prop, Vue } from 'vue-property-decorator'
import Icon from '../../shared/Icon/Icon.vue'
import { TestStatus } from '@shared/types/database'

@Component({ components: { Icon } })
export default class Pill extends Vue {
  @Prop({ required: false }) readonly text!: string;
  @Prop({ required: false }) readonly count!: number;
  @Prop({ required: false }) readonly iconName!: string;

  formatClass () {
    if (!this.isStatus) return 'generic'
    return this.text.replace(/\s+/g, '-')
  }

  get isStatus () {
    return Object.values(TestStatus).includes(this.text as TestStatus)
  }

  get formattedCount () {
    return `\u00A0(${this.count})`
  }
}
